import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { SOLUTIONS } from "../data/content";
import { Reveal, PageHeader, QuoteCTA } from "../components/Shared";

export default function Solutions() {
  return (
    <div data-testid="solutions-page">
      <PageHeader
        tag="Solutions / Products"
        title={<>Displays & Graphics<br />That Sell.</>}
        subtitle="Five core product families, engineered and manufactured in-house — each one built to put your brand in front of the right eyes."
      />

      <div className="pb-8">
        {SOLUTIONS.map((s, i) => (
          <section key={s.id} className="py-16 border-t" style={{ borderColor: "var(--line)" }} data-testid={`solution-section-${s.id}`}>
            <div className={`msg-container grid grid-cols-1 lg:grid-cols-2 gap-12 items-center`}>
              <Reveal className={i % 2 === 1 ? "lg:order-2" : ""}>
                <div className="img-frame aspect-[4/3] relative">
                  <img src={s.image} alt={s.title} loading="lazy" />
                  <span className="corner-notch" />
                </div>
              </Reveal>
              <Reveal delay={0.1} className={i % 2 === 1 ? "lg:order-1" : ""}>
                <span className="font-mono text-sm" style={{ color: s.color }}>{s.num}</span>
                <h2 className="font-display font-black uppercase tracking-tight text-2xl sm:text-3xl lg:text-4xl mt-3">{s.title}</h2>
                <p className="mt-5 text-base md:text-lg leading-relaxed" style={{ color: "var(--text-2)" }}>{s.desc}</p>
                <ul className="mt-7 grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {s.features.map((f) => (
                    <li key={f} className="flex items-center gap-3 text-sm font-medium">
                      <Check size={15} style={{ color: s.color }} className="shrink-0" /> {f}
                    </li>
                  ))}
                </ul>
                <Link to="/quote" className="btn-ghost mt-8" data-testid={`solution-quote-btn-${s.id}`}>
                  Get a Quote <ArrowRight size={14} />
                </Link>
              </Reveal>
            </div>
          </section>
        ))}
      </div>

      <QuoteCTA />
    </div>
  );
}
